import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // Asegúrate que la ruta sea correcta

const AuthRoutes = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  
  if (isLoading) {
    return <div style={{color: 'white', textAlign: 'center', paddingTop: '5rem'}}>Cargando...</div>;
  }

  // Si hay un usuario, no dejes que vea login/signup. Redirígelo al menú.
  if (user) {
    
    const redirectPath = sessionStorage.getItem('post_login_redirect');

    if (redirectPath) {
      return <Navigate to={redirectPath} replace />;
    }

    return <Navigate to="/user/dashboard" replace />;
  }

  // Si no hay usuario, permite que vea la página de login o registro.
  return <Outlet />;
};

export default AuthRoutes;